import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import { Dropdown } from 'semantic-ui-react'
import { translate } from 'loankeeper-common/helpers'
import { LKIcon } from 'loankeeper-common/components'

import LKButton from 'shared/LKButton'
import { actions as LKModalActions } from '../shared/LKModal'
import { usePermissions } from '../shared/containers/withConstantPermissions'

import { DecoratedMemorialOrder } from './MemorialOrderAdd'
import { DecoratedCashInOutAddModal } from './CashInOut'
import { DecoratedConvertOnAccountModal, DecoratedConvertInCashModal } from './ConvertOnAccountInCash'

const DropdownComponent = styled.div`
  display: inline-block;

  .ui.dropdown .menu {
    left: initial;
    right: 0px;
  }

  .ui.dropdown .menu > .item {
    display: flex !important;
    padding: 5px !important;
    align-items: center;
  }
`

const OrderAddDropdown = (props) => {
  const dispatch = useDispatch()

  const {
    ACC_ENTRIES_ADD_MEMORDER,
    ACC_ENTRIES_ADD_CASHIN,
    ACC_ENTRIES_ADD_CASHOUT,
    ACC_ENTRIES_ADD_CONV,
    ACC_ENTRIES_ADD_CONV_CASH,
  } = usePermissions()

  function handleDropdownChange(_, { value }) {
    dispatch(LKModalActions.open({ name: value, LoanID: props.LoanID, LoanHash: props.LoanHash }))
  }

  const { onOrderAdd, children, alias, upward, account } = props

  return (
    <>
      <DropdownComponent>
        <Dropdown
          onChange={handleDropdownChange}
          trigger={<LKButton alias={alias}>{children}</LKButton>}
          icon={null}
          upward={upward}
          selectOnBlur={false}
          value={null}
          options={[
            ACC_ENTRIES_ADD_MEMORDER && {
              key: 'memorder',
              value: 'AccountViewMemorialOrderAdd',
              text: translate('frm_acc_entry_add-lbl_ot_memorder'),
              icon: <LKIcon alias="entries_memorial" size={20} style={{ marginRight: 5 }} />,
            },
            ACC_ENTRIES_ADD_CASHIN && {
              key: 'cashin',
              value: 'AccountViewCashInAdd',
              text: translate('frm_acc_entry_add-lbl_ot_cash_income'),
              icon: <LKIcon alias="entries_cashin" size={20} style={{ marginRight: 5 }} />,
            },
            ACC_ENTRIES_ADD_CASHOUT && {
              key: 'cashout',
              value: 'AccountViewCashOutAdd',
              text: translate('frm_acc_entry_add-lbl_ot_cash_expense'),
              icon: <LKIcon alias="entries_cashout" size={20} style={{ marginRight: 5 }} />,
            },
            ACC_ENTRIES_ADD_CONV && {
              key: 'convertOnAccount',
              value: 'AccountViewConvertOnAccountAdd',
              text: translate('frm_acc_entry_add-lbl_ot_exchange_acc'),
              icon: <LKIcon alias="entries_conv" size={20} style={{ marginRight: 5 }} />,
            },
            ACC_ENTRIES_ADD_CONV_CASH && {
              key: 'convertInCash',
              value: 'AccountViewConvertInCashAdd',
              text: translate('frm_acc_entry_add-lbl_ot_exchange_cash'),
              icon: <LKIcon alias="entries_convcash" size={20} style={{ marginRight: 5 }} />,
            },
          ].filter(Boolean)}
        />
      </DropdownComponent>

      <DecoratedMemorialOrder
        OperTypeID={1}
        onOrderAddEdit={onOrderAdd}
        name="AccountViewMemorialOrderAdd"
        account={account}
      />

      <DecoratedCashInOutAddModal
        OperTypeID={3}
        onOrderAddEdit={onOrderAdd}
        name="AccountViewCashInAdd"
        account={account}
      />

      <DecoratedCashInOutAddModal
        OperTypeID={4}
        onOrderAddEdit={onOrderAdd}
        name="AccountViewCashOutAdd"
        account={account}
        cashOut
      />

      <DecoratedConvertOnAccountModal
        OperTypeID={6}
        onOrderAddEdit={onOrderAdd}
        name="AccountViewConvertOnAccountAdd"
      />

      <DecoratedConvertInCashModal
        OperTypeID={7}
        onOrderAddEdit={onOrderAdd}
        inCash
        name="AccountViewConvertInCashAdd"
      />
    </>
  )
}

OrderAddDropdown.defaultProps = {
  alias: 'add',
  upward: false,
}

export default OrderAddDropdown
